import { BLOCK_TYPE, COMMAND } from '../../utilities/CONSTANTS';

const converters = [
    {
        blockType: BLOCK_TYPE.ORDERED_LIST,
        command: COMMAND.automarkdownOrderedList,
        regex: /^1\.\s$/,
    },
    {
        blockType: BLOCK_TYPE.UNORDERED_LIST,
        command: COMMAND.automarkdownUnorderedList,
        regex: /^(\*|-)\s$/,
    },
    {
        blockType: BLOCK_TYPE.H1,
        command: COMMAND.automarkdownHeaderOne,
        regex: /^#\s$/,
    },
    {
        blockType: BLOCK_TYPE.H2,
        command: COMMAND.automarkdownHeaderTwo,
        regex: /^##\s$/,
    },
    {
        blockType: BLOCK_TYPE.H3,
        command: COMMAND.automarkdownHeaderThree,
        regex: /^###\s$/,
    },
    {
        blockType: BLOCK_TYPE.CODE,
        command: COMMAND.automarkdownCode,
        regex: /^```\s$/,
    },
    {
        blockType: BLOCK_TYPE.HR,
        command: COMMAND.automarkdownHR,
        regex: /^[-]{3,4}\s$/,
    },
];

export default converters;
